import React from 'react';
import './style.scss';

function App() {
  return (
    <div className="App">
    </div>
  );
}

export default App;
